import Swal from "sweetalert2";

/**
 * Shared "are you sure?" confirmation, styled via `ConfirmDialogGlobalStyle` (mounted once in
 * `library/GlobalStyles.js`) instead of per-call-site colors. Resolves to a plain boolean so callers don't need to
 * check `result.isConfirmed` themselves.
 */
export function confirmDialog({ title = "Are you sure?", text, icon = "warning", confirmButtonText = "Yes, remove it!" } = {}) {
    return Swal.fire({
        title,
        text,
        icon,
        showCancelButton: true,
        confirmButtonText,
        customClass: { popup: "ami-confirm-dialog" },
    }).then((result) => result.isConfirmed);
}
